<app-navbar></app-navbar>

<div class="page-container">
  <div class="banner"></div>

  <div class="content-container">
    <div class="page-header">
      <button class="back-btn" (click)="cancelAndEditReservation()">
        <i class="fas fa-arrow-left"></i>
        <span>Volver a Editar</span>
      </button>
      <h1 class="page-title">Completar Reserva</h1>
      <div class="step-indicator">
        <span class="step active">2</span>
        <span class="step-text">Registrar Huéspedes</span>
      </div>
    </div>

    <div class="main-content">
      <!-- Columna Izquierda: Resumen de la Reserva -->
      <div class="reservation-summary-section">
        <div class="summary-card">
          <div class="card-header">
            <i class="fas fa-clipboard-list"></i>
            <h2>Resumen de la Reserva</h2>
          </div>

          @if (reservationSummary && hosting) {
          <div class="reservation-details">
            <!-- Header con imagen y datos principales -->
            <div class="accommodation-header">
              <div class="accommodation-image">
                <img [src]="hosting.images" [alt]="hosting.name" />
                <div class="image-overlay">
                  <span class="accommodation-type">{{ hosting.room.type }}</span>
                </div>
              </div>
              <div class="accommodation-info">
                <h3 class="accommodation-name">{{ hosting.name }}</h3>
                <p class="reservation-id">
                  <i class="fas fa-id-card"></i>
                  ID: {{ reservationSummary.reservation_id }}
                </p>
                <div class="dates-info">
                  <div class="date-item">
                    <i class="fas fa-calendar-plus"></i>
                    <span class="date-label">Check-in:</span>
                    <span class="date-value">{{ reservationSummary.checkInDate | date:'d MMM yyyy' }}</span>
                  </div>
                  <div class="date-item">
                    <i class="fas fa-calendar-minus"></i>
                    <span class="date-label">Check-out:</span>
                    <span class="date-value">{{ reservationSummary.checkOutDate | date:'d MMM yyyy' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Detalles de precio -->
            <div class="pricing-section">
              <h3 class="section-title">
                <i class="fas fa-money-bill-wave"></i>
                Información del Precio
              </h3>

              <!-- Costo de alojamiento -->
              <div class="cost-breakdown">
                <h4 class="cost-category">Costo de Alojamiento</h4>
                <div class="cost-details">
                  <div class="cost-item">
                    <span class="cost-label">Precio básico por noche:</span>
                    <span class="cost-value">{{ reservationSummary.basic_room_cost | currency: 'COP ':'symbol':'1.2-2'
                      }}</span>
                  </div>
                  <div class="cost-item">
                    <span class="cost-label">Número de noches:</span>
                    <span class="cost-value">{{ reservationSummary.numberOfNights }}</span>
                  </div>
                  <div class="cost-item">
                    <span class="cost-label">Número de huéspedes:</span>
                    <span class="cost-value">{{ reservationSummary.numAdults + reservationSummary.numChildren +
                      reservationSummary.numInfants }}</span>
                  </div>
                  <div class="cost-item subtotal">
                    <span class="cost-label">Subtotal Alojamiento:</span>
                    <span class="cost-value">{{ reservationSummary.subtotal_accommodation | currency: 'COP
                      ':'symbol':'1.2-2' }}</span>
                  </div>
                </div>
              </div>

              <!-- Servicios adicionales -->
              <div class="cost-breakdown">
                <h4 class="cost-category">Servicios Adicionales</h4>
                <div class="cost-details">
                  @if (additionalServicesDetails && additionalServicesDetails.length > 0) {
                  @for (service of additionalServicesDetails; track service.id) {
                  <div class="cost-item service-item">
                    <span class="cost-label">{{ service.name }}:</span>
                    <span class="cost-value">{{ service.cost | currency: 'COP ':'symbol':'1.2-2' }}</span>
                  </div>
                  }
                  } @else {
                  <div class="cost-item">
                    <span class="cost-label">Sin servicios adicionales</span>
                    <span class="cost-value">$0</span>
                  </div>
                  }
                  <div class="cost-item subtotal">
                    <span class="cost-label">Subtotal Servicios:</span>
                    <span class="cost-value">{{ reservationSummary.subtotal2 | currency: 'COP ':'symbol':'1.2-2'
                      }}</span>
                  </div>
                </div>
              </div>

              <!-- Impuestos y total -->
              <div class="cost-breakdown">
                <h4 class="cost-category">Impuestos</h4>
                <div class="cost-details">
                  <div class="cost-item">
                    <span class="cost-label">IVA (19%):</span>
                    <span class="cost-value">{{ reservationSummary.totalTaxes | currency: 'COP ':'symbol':'1.2-2'
                      }}</span>
                  </div>
                </div>
              </div>

              <div class="total-section">
                <div class="total-amount">
                  <span class="total-label">Total a Pagar:</span>
                  <span class="total-value">{{ reservationSummary.totalReservation | currency: 'COP ':'symbol':'1.2-2'
                    }}</span>
                </div>
                <div class="status-badge" [class]="getStatusClass(reservationSummary.status)">
                  <i class="fas fa-info-circle"></i>
                  {{ reservationSummary.status }}
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>

      <!-- Columna Derecha: Formulario de Huéspedes -->
      <div class="guest-form-section">
        <div class="form-card">
          <div class="card-header">
            <i class="fas fa-users"></i>
            <h2>Información de los Huéspedes</h2>
          </div>

          <!-- Información sobre el proceso -->
          <div class="process-info">
            <div class="process-header">
              <i class="fas fa-route"></i>
              <h3>Pasos para completar tu reserva</h3>
            </div>
            <div class="process-steps">
              <div class="step-item current">
                <div class="step-number">1</div>
                <div class="step-content">
                  <span class="step-title">Registra los huéspedes</span>
                  <span class="step-description">Completa la información de todas las personas</span>
                </div>
              </div>
              <div class="step-item">
                <div class="step-number">2</div>
                <div class="step-content">
                  <span class="step-title">Ir al dashboard</span>
                  <span class="step-description">Serás redirigido a "Mis Reservas"</span>
                </div>
              </div>
              <div class="step-item">
                <div class="step-number">3</div>
                <div class="step-content">
                  <span class="step-title">Realizar el pago</span>
                  <span class="step-description">Genera el link de pago de MercadoPago</span>
                </div>
              </div>
              <div class="step-item">
                <div class="step-number">4</div>
                <div class="step-content">
                  <span class="step-title">Confirmación</span>
                  <span class="step-description">Tu reserva quedará confirmada</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Formulario -->
          <form [formGroup]="guestForm" (ngSubmit)="onSubmit()" class="guests-form">
            <div formArrayName="guests" class="guests-container">
              @for (guest of guests; track i; let i = $index) {
              <div [formGroupName]="i" class="guest-card">
                <div class="guest-header">
                  <div class="guest-icon">
                    <i class="fas fa-user"></i>
                  </div>
                  <h3 class="guest-title">Huésped {{ i + 1 }}</h3>
                  @if (i === 0) {
                  <span class="primary-badge">Principal</span>
                  }
                </div>

                <div class="guest-form-content">
                  <div class="form-group-row">
                    <div class="form-group">
                      <label class="form-label" [for]="'name-' + i">
                        <i class="fas fa-user"></i>
                        <span>Nombre</span>
                      </label>
                      <input type="text" [id]="'name-' + i" formControlName="name" class="form-input"
                        placeholder="Ingresa el nombre" required />
                    </div>

                    <div class="form-group">
                      <label class="form-label" [for]="'lastname-' + i">
                        <i class="fas fa-user-tag"></i>
                        <span>Apellido</span>
                      </label>
                      <input type="text" [id]="'lastname-' + i" formControlName="lastname" class="form-input"
                        placeholder="Ingresa el apellido" required />
                    </div>
                  </div>

                  <div class="form-group-row">
                    <div class="form-group">
                      <label class="form-label" [for]="'identification-type-' + i">
                        <i class="fas fa-id-card"></i>
                        <span>Tipo de Identificación</span>
                      </label>
                      <select [id]="'identification-type-' + i" formControlName="identificationType" class="form-select"
                        required>
                        <option value="">Selecciona el tipo</option>
                        <option value="Cédula de ciudadanía">Cédula de ciudadanía</option>
                        <option value="Cédula de extranjería">Cédula de extranjería</option>
                        <option value="Tarjeta de identidad">Tarjeta de identidad</option>
                        <option value="registro-civil">Registro civil</option>
                        <option value="Pasaporte">Pasaporte</option>
                        <option value="permiso-permanencia">Permiso especial de permanencia</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <label class="form-label" [for]="'identification-number-' + i">
                        <i class="fas fa-hashtag"></i>
                        <span>Número de Identificación</span>
                      </label>
                      <input type="text" [id]="'identification-number-' + i" formControlName="identificationNumber"
                        class="form-input" placeholder="Número de documento" required />
                    </div>
                  </div>

                  <div class="form-group-row">
                    <div class="form-group">
                      <label class="form-label" [for]="'phone-' + i">
                        <i class="fas fa-phone"></i>
                        <span>Teléfono</span>
                      </label>
                      <input type="tel" [id]="'phone-' + i" formControlName="phone" class="form-input"
                        placeholder="+57 300 123 4567" required />
                    </div>

                    <div class="form-group">
                      <label class="form-label" [for]="'emergency-phone-' + i">
                        <i class="fas fa-phone-alt"></i>
                        <span>Teléfono de Emergencia</span>
                      </label>
                      <input type="tel" [id]="'emergency-phone-' + i" formControlName="emergencyPhone"
                        class="form-input" placeholder="+57 300 123 4567" required />
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>

            <div class="form-actions">
              <button type="submit" class="submit-btn" [disabled]="guestForm.invalid" [class.loading]="isLoading">
                @if (isLoading) {
                <i class="fas fa-spinner fa-spin"></i>
                <span>Guardando...</span>
                } @else {
                <i class="fas fa-save"></i>
                <span>Guardar Información de Huéspedes</span>
                }
              </button>
            </div>
          </form>

          @if (showSuccess) {
          <div class="success-message">
            <div class="success-icon">
              <i class="fas fa-check-circle"></i>
            </div>
            <div class="success-content">
              <h3>¡Información guardada exitosamente!</h3>
              <p class="success-description">
                Los datos de tus huéspedes se han registrado correctamente.<br>
                Serás redirigido a tu dashboard para gestionar el pago de la reserva...
              </p>
              <div class="success-progress">
                <div class="progress-bar"></div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>